import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteClienteCadastro } from '../service';
import {
  DELETE_CLIENTE_CADASTRO,
  DELETE_CLIENTE_CADASTRO_PENDING,
  DELETE_CLIENTE_CADASTRO_SUCCESS,
  DELETE_CLIENTE_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteClienteCadastro(action) {
  yield put({ type: DELETE_CLIENTE_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.CLIENTE_EXCLUIR);

  try {
    const a = yield call(deleteClienteCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_CLIENTE_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_CLIENTE_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Verifique se o cliente não está vinculado em outra movimentação no sistema...');
  }
}

export default function* watchDeleteClienteCadastro() {
  yield takeLatest(DELETE_CLIENTE_CADASTRO, sagaDeleteClienteCadastro)
}
